import { atom } from 'jotai';

export const scrollLockAtom = atom<string[]>([]);

scrollLockAtom.debugLabel = 'scrollLockAtom';
